export enum InputTypeEnum {
    volts = 1,
    milliVolts
}
